export const ListQueryKey = 'rounds';
export const DetailQueryKey = 'round';
export const Urls = {
  selectUrl: '/a/issue/list',
  updateUrl: '/a/issue/update',
  deleteUrl: '/a/issue/delete',
  createUrl: '/a/issue/create',
  detailUrl: '/a/issue/detail'
};